import Model from "./Model";
import Hash from "../utils/Hash";
import AssemblyParameters from './AssemblyParameters';
import DatasetColumn from "./DatasetColumn";

export default class Assembly extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			guid: Hash.guid(),
			name: null,
			component: null,
			dataset: null,
			duration: null,
			parameters: {},
		}, props);

		this.parameters = new AssemblyParameters(this.parameters);
	}

	isValid(component, dataset) {

		if (!this.component || !this.dataset || !component || !dataset) {
			return false;
		}

		const types = ['component', 'dataset'];
		for (let i = 0; i < types.length; i++) {
			const type = types[i];
			for (let i = 0; i < component.compiled_parameters[type].parameters.length; i++) {
				const parameter = component.compiled_parameters[type].parameters[i];
				if (parameter.mandatory === true) {

					if (this.parameters[type][parameter.key] === undefined) {
						return false;
					} else if (parameter.type === 'column' && !dataset.columns.find(column => this.parameters[type][parameter.key] === column.guid)) {
						return false;
					}
				}
			}
		}

		return true;
	}

	getTestPath(datasetId) {
		const json = JSON.stringify(this.parameters);
		return '/test/component/' + this.component + '?p=' + encodeURIComponent(json) + (datasetId ? '&d=' + datasetId : '');
	}
}
